module.exports = __webpack_public_path__ + "img/btn_menu_zyz.9c4ce830.png";